export const SET_STEP = Symbol('SET_STEP');
export const NEXT_STEP = Symbol('NEXT_STEP');
export const STORE_STEPS = Symbol('STORE_STEPS');

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function setStep (activeIndex) {

	return {
		type: SET_STEP,
		activeIndex: activeIndex
	};
}

export function storeStepsData (steps) {

	return {
		type: STORE_STEPS,
		steps: steps
	};
}

export function nextStep () {

	return {
		type: NEXT_STEP
	};
}
